import styled from "styled-components";

export const CardAttributeContainer = styled.h5`
background-color: ${(props) => {
        if (props.color) {
            const hex = props.color.replace('#', '');
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return `rgba(${r}, ${g}, ${b}, 0.15)`;
        }
        return 'rgba(255, 255, 255, 0.15)';
    }};
    border: ${(props) => {
        const thickness = "2px";
        if (props.color) {
            const hex = props.color.replace('#', '');
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return `solid ${thickness} rgba(${r}, ${g}, ${b}, 0.45)`;
        }
        return `solid ${thickness} rgba(255, 255, 255, 0.45)`;
    }};
    border-radius: 100px;
    box-sizing: border-box;
    color: #FFFFFF;
    text-transform: uppercase;
    cursor: ${(props) => props.$clickable ? 'pointer' : 'default'};
    font-family: 'Roboto Condensed', sans-serif;
    font-size: ${(props) => props.size === "S" ? "14px" : "16px"};
    font-weight: 500;
    padding: 4px 10px;
    transition: ${(props) => props.$clickable ? 'background-color 0.15s ease, opacity 0.15s ease' : 'none'};
    width: fit-content;

    &:hover {
        ${(props) => props.$clickable && `
            background-color: rgba(255, 255, 255, 0.35);
            opacity: 0.85;
        `}
    }

    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
`